/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectFinancialSummaryQuery } from '../../models/get-project-financial-summary-query';
import { GetProjectFinancialSummaryQueryResult } from '../../models/get-project-financial-summary-query-result';

export interface ApiProjectFinancialSummariesGetProjectFinancialSummaryPost$Params {
      body?: GetProjectFinancialSummaryQuery
}

export function apiProjectFinancialSummariesGetProjectFinancialSummaryPost(http: HttpClient, rootUrl: string, params?: ApiProjectFinancialSummariesGetProjectFinancialSummaryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectFinancialSummaryQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectFinancialSummariesGetProjectFinancialSummaryPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectFinancialSummaryQueryResult>;
    })
  );
}

apiProjectFinancialSummariesGetProjectFinancialSummaryPost.PATH = '/api/ProjectFinancialSummaries/GetProjectFinancialSummary';
